export const generator = "https://github.com/jpmonette/feed";
